import { imageHashesService, type ImageHashFilters } from "../api/imageHashes.service.js";
import { useMutation, useQuery } from "./useApi.js";

/**
 * Hook to fetch WordPress image-cache entries with pagination + search.
 */
export function useImageHashes(filters: ImageHashFilters) {
  return useQuery(
    () => imageHashesService.listImageHashes(filters),
    [filters.limit, filters.offset, filters.search],
  );
}

/**
 * Hook to fetch aggregate stats for the WordPress image cache.
 */
export function useImageHashStats() {
  return useQuery(() => imageHashesService.getImageHashStats(), []);
}

/**
 * Hook to clear the entire WordPress image cache.
 */
export function useClearImageHashes() {
  return useMutation(() => imageHashesService.clearImageHashes());
}
